module.exports = __webpack_public_path__ + "img/ess_ultraplatinum.56d883ce.png";